(function () {
  if (window.customallCartPreviewInitialized) return;
  window.customallCartPreviewInitialized = true;

  function createModal() {
    if (document.getElementById('customall-cart-preview-modal')) return;

    const modal = document.createElement('div');
    modal.id = 'customall-cart-preview-modal';
    modal.className = 'customall-cart-preview-modal';
    modal.setAttribute('aria-hidden', 'true');

    modal.innerHTML = `
      <div class="customall-cart-preview-modal__dialog" role="dialog" aria-modal="true" aria-label="Preview image">
        <img
          class="customall-cart-preview-modal__image"
          id="customall-cart-preview-image"
          src=""
          alt=""
        >
        <button
          type="button"
          class="customall-cart-preview-modal__close"
          id="customall-cart-preview-close"
          aria-label="Close preview"
        >
          &times;
        </button>
      </div>
    `;

    document.body.appendChild(modal);

    modal.addEventListener('click', function (event) {
      if (
        event.target === modal ||
        event.target.id === 'customall-cart-preview-close'
      ) {
        closeModal();
      }
    });
  }

  function normalizePreviewUrl(imageUrl) {
    const rawUrl = String(imageUrl || '')
      .replace(/\\\//g, '/')
      .replace(/&amp;/g, '&')
      .trim();
    const match = rawUrl.match(/https?:\/\/[^\s"'<>\\\]}),]+|blob:[^\s"'<>\\\]}),]+|data:image\/[^\s"'<>]+/i);
    const safeUrl = match ? match[0] : rawUrl;
    const safeUrlLower = safeUrl.toLowerCase();

    if (!safeUrl) return '';
    if (safeUrlLower.includes('/products/')) return '';
    if (safeUrlLower.includes('sf_private_access_tokens')) return '';
    if (safeUrlLower.startsWith('blob:') || safeUrlLower.startsWith('data:image/')) return safeUrl;
    if (!safeUrlLower.startsWith('http://') && !safeUrlLower.startsWith('https://')) return '';

    const isImageUrl =
      /\.(png|jpe?g|webp|gif|svg)(\?|#|$)/i.test(safeUrlLower) ||
      safeUrlLower.includes('assets-v2.customall.io') ||
      safeUrlLower.includes('cdn.customall.io') ||
      safeUrlLower.includes('cdn.shopify.com') ||
      safeUrlLower.includes('cloudfront.net') ||
      safeUrlLower.includes('/cdn/');

    return isImageUrl ? safeUrl : '';
  }

  function openModal(imageUrl, imageAlt) {
    createModal();

    const modal = document.getElementById('customall-cart-preview-modal');
    const image = document.getElementById('customall-cart-preview-image');
    const safeImageUrl = normalizePreviewUrl(imageUrl);

    if (!modal || !image || !safeImageUrl) return false;

    image.src = safeImageUrl;
    image.alt = imageAlt || 'Preview image';

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('customall-preview-lock');
    return true;
  }

  function closeModal() {
    const modal = document.getElementById('customall-cart-preview-modal');
    const image = document.getElementById('customall-cart-preview-image');

    if (!modal || !image) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    image.src = '';
    image.alt = '';
    document.body.classList.remove('customall-preview-lock');
  }

  document.addEventListener('click', function (event) {
    const previewButton = event.target.closest('.inkybox-preview-button, .cart-item__preview-button, .cart-notification-product__preview-button');

    if (!previewButton) return;

    event.preventDefault();
    event.stopPropagation();

    openModal(
      previewButton.getAttribute('data-preview-url'),
      previewButton.getAttribute('data-preview-alt')
    );
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeModal();
    }
  });

  window.InkyboxCartPreview = Object.assign({}, window.InkyboxCartPreview || {}, {
    open: openModal,
    close: closeModal,
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', createModal);
  } else {
    createModal();
  }
})();
